import { useState } from "react";
import { api } from "@/api/client";
import { Logo } from "@/components/Logo";

/* PM-account password auth (2026-02) — always shows the SAME generic confirmation regardless of
 * whether the email matched a real account (no enumeration, matching the backend's own
 * /auth/forgot-password contract — see server.py). */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); }
    catch { /* the endpoint itself never errors on a bad/unknown email — network issues only */ }
    finally { setBusy(false); setSent(true); }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-canvas px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-[380px]">
        <div className="mb-7 flex flex-col items-start gap-4">
          <Logo theme="light" size="md" testId="forgot-password-logo" />
          <div>
            <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-faint">Account recovery</div>
            <h2 className="font-editorial text-2xl text-ink mt-1">Reset your password</h2>
          </div>
        </div>

        {sent ? (
          <div data-testid="forgot-password-message" className="text-sm text-ink-soft leading-relaxed bg-white border border-hairline rounded-md px-4 py-4">
            If that account exists, a password reset link is on its way. It's valid for 1 hour and can only be used once.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-[11px] font-medium uppercase tracking-wider text-faint mb-1.5">Email</label>
              <input
                data-testid="forgot-password-email-input"
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-md border border-hairline bg-white px-3 py-2.5 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/30 transition-all"
              />
            </div>
            <button
              data-testid="forgot-password-submit"
              disabled={busy}
              className="w-full rounded-md bg-brand py-2.5 text-sm font-semibold text-ink hover:bg-brand-dim disabled:opacity-50 transition-colors"
            >{busy ? "Sending…" : "Send reset link"}</button>
          </form>
        )}

        <div className="mt-7 pt-6 border-t border-hairline">
          <a href="/login" data-testid="forgot-password-back-to-login" className="text-[11px] text-faint hover:text-ink transition-colors">← Back to sign in</a>
        </div>
      </div>
    </div>
  );
}
